import { format } from 'date-fns';
import { nb, enUS } from 'date-fns/locale';
import i18n from '../i18n/config';

export const formatLocalizedDate = (dateString: string): string => {
  const locale = i18n.language === 'en' ? enUS : nb;
  return format(new Date(dateString), 'dd.MM.yyyy', { locale });
};

/**
 * @deprecated Use formatLocalizedDate instead
 */
export const formatNorwegianDate = (dateString: string): string => {
  return formatLocalizedDate(dateString);
};
